/* Alta gioielleria aggiunta il 16/10: i gioielli da 8.000 € in su escono da Shopify (prodotti archiviati)
   e diventano schede su appuntamento, senza prezzo, come gli 84 pezzi di em-dati.js.
   Regola di Eleonora: da 8.000 € in su il prezzo non si mostra. Va caricato dopo em-dati.js e prima di em-app.js.
   Le foto uniformate (em-<handle>-<n>.jpg) sono già nei File; video e foto mancanti arrivano dai media del prodotto archiviato. */
(function () {
  var D = window.EM_DATI;
  if (!D || !D.x || !D.ag) return;
  D.descr = D.descr || {};
  D.descr_en = D.descr_en || {};
  var CDN = 'https://cdn.shopify.com/s/files/1/0789/8424/9688/files/';
  var VID = function (id, n, v) {
    return { v: 'https://cdn.shopify.com/videos/c/vp/' + id + '/' + id + '.HD-720p-4.5Mbps-' + n + '.mp4', p: CDN + 'preview_images/' + id + '.thumbnail.0000000000.jpg?v=' + v };
  };
  var COL = { Anelli: 'anelli', Orecchini: 'earrings', Bracciali: 'bracelets', Collane: 'necklaces' };
  /* handle, titolo, titolo inglese, descrizione, descrizione inglese, video, foto (solo se mancano quelle uniformate), dati se il gioiello non è in em-dati.js */
  var ALTA = [
    ['rainbow-round-tennis', 'Bracciale tennis RAINBOW ROUND', 'Rainbow Round Tennis Bracelet',
      'Bracciale tennis in oro rosa 18 kt (11,42 g) con zaffiri colorati (5,42 ct).', 'Tennis bracelet in 18k rose gold with colored sapphires (5.42 ct). 11.42 g.',
      VID('159fae8914e047dd823a0186bfe4b106', '20036365', '1698666344')],
    ['white-snake-earrings', 'Orecchini WHITE SNAKE', 'White Snake Earrings',
      'Orecchini in oro bianco 18 kt (19,60 g) con diamanti bianchi (2,39 ct).', 'Earrings in 18k white gold with white diamonds (2.39 ct). 19.60 g.',
      VID('31a52f3e60c1497ca0bcedbb1072b72d', '21216508', '1701082393')],
    ['ruby-diamonds-ring', 'Anello RUBY & DIAMONDS', 'Ruby & Diamonds Ring',
      'Anello in oro bianco 18 kt (6,40 g) con rubini (2,08 ct) e diamanti (2,08 ct).', 'Ring in 18k white gold with rubies (2.08 ct) and diamonds (2.08 ct). 6.40 g.'],
    ['arabesque-earrings', 'Orecchini ARABESQUE', 'Arabesque Earrings',
      'Orecchini in oro bianco 18 kt con diamanti (2,91 ct) e perle bianche.', 'Earrings in 18k white gold with diamonds (2.91 ct) and white pearls.'],
    ['front-hoop-earrings', 'Orecchini FRONT HOOP', 'Front Hoop Earrings',
      'Orecchini in oro bianco (12,66 g) con diamanti bianchi (3,13 ct).', 'Earrings in white gold with white diamonds (3.13 ct). 12.66 g.',
      VID('0a80657ca2924839aeeb6b49c9fc12d3', '22193775', '1703068895')],
    ['pear-and-oval-diamonds-ring', 'Anello PEAR AND OVAL DIAMONDS', 'Pear and Oval Diamonds Ring',
      'Anello in oro bianco (5,05 g) con diamante ovale (0,53 ct), diamante a goccia (0,50 ct) e diamanti tondi (0,25 ct).', 'Ring in white gold with an oval-cut diamond (0.53 ct), a pear-cut diamond (0.50 ct) and round diamonds (0.25 ct). 5.05 g.',
      VID('b025c5064e424a5db3c04714868bda1d', '28772978', '1715076144')],
    ['05240485', 'Anello TURQUOISE', 'Turquoise Ring',
      'Anello in oro giallo (16,31 g) con turchese (11,31 ct), diamanti brown (1,41 ct) e diamanti bianchi (0,75 ct).', 'Ring in yellow gold with turquoise (11.31 ct), brown diamonds (1.41 ct) and white diamonds (0.75 ct). 16.31 g.',
      VID('d4b1818bc8f74574af6fc53ff8c1c221', '29359606', '1716194625')],
    ['pave-diamonds-tennis-bracelet', 'Bracciale PAVÉ DIAMONDS TENNIS', 'Pavé Diamonds Tennis Bracelet',
      'Bracciale in oro bianco (25,00 g) con diamanti bianchi (3,26 ct).', 'Bracelet in white gold with white diamonds (3.26 ct). 25.00 g.',
      VID('6fe9b73bc2bc45b9a86cc122987a2ce2', '38698271', '1732532217'),
      [CDN + 'BL-0031_ufr2uvuev7l_2024-11-25-11-54-45_ee9dbd74-42c9-487f-8cf1-7ab1f4b427fd.jpg?v=1732532177'],
      [0, 'Bracciali', ['Oro bianco'], ['diamante'], [0], []]],
    ['anello-flower-diamond', 'Anello FLOWER DIAMOND', 'Flower Diamond Ring',
      'Anello con diamanti (2,22 ct).', 'Ring with diamonds (2.22 ct).',
      VID('fd2f5a36bbd344bcb4248103837e3962', '39074298', '1733150442')],
    ['orecchini-arctic-flame', 'Orecchini ARCTIC FLAME', 'Arctic Flame Earrings',
      'Orecchini in oro bianco 18 kt, intreccio tondo con zaffiri blu (2,13 ct) e diamanti bianchi (1,64 ct).', 'Earrings in 18k white gold with a round interlaced motif, blue sapphires (2.13 ct) and white diamonds (1.64 ct).'],
    ['collana-blue-orbit', 'Collana BLUE ORBIT', 'Blue Orbit Necklace',
      'Collana in oro (12,18 g) con diamanti (1,45 ct) e zaffiro (10,15 ct).', 'Gold necklace with diamonds (1.45 ct) and a sapphire (10.15 ct). 12.18 g.',
      VID('3383275e64fe4c458862d9b509387a72', '45930197', '1744628924')],
    ['anello-verdelux', 'Anello VERDELUX', 'Verdelux Ring',
      'Anello in oro 18 kt (2,90 g) con smeraldi (3,61 ct).', 'Ring in 18k gold with emeralds (3.61 ct). 2.90 g.',
      VID('c7e725888f6d49f9ad95d8c797b50dd5', '46186394', '1744973983')],
    ['collana-sunbound', 'Collana SUNBOUND', 'Sunbound Necklace',
      'Collana in oro con pendente con diamanti brown (1,11 ct) e diamanti (2,48 ct). 17,70 g.', 'Gold necklace with a pendant set with brown diamonds (1.11 ct) and diamonds (2.48 ct). 17.70 g.',
      VID('09ae4a2a061c4f8cbcdfa8ecbb1661d4', '47829348', '1747653489')],
    ['anello-bond-of-fire', 'Anello BOND OF FIRE', 'Bond of Fire Ring',
      'Anello in oro con diamanti (2,95 ct) e diamante verde (1 ct). 12,20 g.', 'Gold ring with diamonds (2.95 ct) and a green diamond (1 ct). 12.20 g.',
      VID('6c3f8d3a96de457293ffd83ec74cc2f3', '47832987', '1747657772')],
    ['bracciale-royale', 'Bracciale ROYALE', 'Royale Bracelet',
      'Bracciale tennis in oro con diamanti (4,37 ct). 9,50 g.', 'Gold tennis bracelet with diamonds (4.37 ct). 9.50 g.',
      VID('2a9ee53aef5340bd9cfbf5db1bc12b69', '47835286', '1747660666')],
    ['orecchini', 'Orecchini ARTEMISIA', 'Artemisia Earrings',
      'Orecchini in oro con diamanti (2,33 ct). 8,00 g.', 'Gold earrings with diamonds (2.33 ct). 8.00 g.',
      VID('6fca789fcb0c4918a77657092aa3ab1b', '49467511', '1750067406')],
    ['orecchini-eclat', 'Orecchini ÉCLAT', 'Éclat Earrings',
      'Orecchini in oro con diamanti (1,46 ct) e diamanti marquise (0,52 ct).', 'Gold earrings with diamonds (1.46 ct) and marquise-cut diamonds (0.52 ct).']
  ];
  var media = {};
  ALTA.forEach(function (a, k) {
    var h = a[0], x = D.x[h] || a[7];
    if (!x || D.ag.some(function (g) { return g.h === h; })) return;
    var foto = a[6];
    D.ag.push({ h: h, t: a[1], tip: x[1], met: x[2], pie: x[3], col: COL[x[1]] ? [COL[x[1]]] : [],
      n: foto ? foto.length : x[4].length, u: foto ? foto.map(function () { return 0; }) : x[4], amb: x[5] || [], v: 0, o: 600 + k, te: a[2] });
    D.descr[h] = a[3];
    D.descr_en[h] = a[4];
    delete D.x[h];
    if (a[5] || foto) media[h] = { vid: a[5], foto: foto };
  });
  /* em-app.js costruisce le schede da D.ag e le espone in window.EM.AG: appena esiste, si aggiungono video e foto dei prodotti */
  var em;
  Object.defineProperty(window, 'EM', {
    configurable: true,
    get: function () { return em; },
    set: function (v) {
      em = v;
      ((v && v.AG) || []).forEach(function (p) {
        var m = media[p.h];
        if (!m) return;
        if (m.vid) p.vid = m.vid;
        if (m.foto) p.u = m.foto.slice();
      });
    }
  });
})();
